import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChartSeriesSwatch } from '../../atoms/ChartMarker/ChartMarker.js';
import { chartSeriesStyle } from '../../lib/chart-series.js';
import { cn } from '../../lib/cn.js';
/**
 * Which line is which. A list, so a screen reader hears one entry after
 * another rather than a run-on sentence, and each entry repeats the series'
 * dash and marker as well as its colour, so a name is never tied to a hue
 * alone. Wraps onto as many rows as it needs; a long name wraps within its
 * entry rather than pushing the row sideways.
 *
 * Shown for two series or more. One series needs no key: the chart's heading
 * or filter already names it.
 */
export function ChartLegend({ label, items, className }) {
    if (items.length < 2)
        return null;
    return (_jsx("ul", { "aria-label": label, className: cn('flex flex-wrap gap-x-5 gap-y-2', className), children: items.map((item) => (_jsxs("li", { className: "flex min-w-0 items-center gap-2 text-body-sm text-text", children: [_jsx(ChartSeriesSwatch, { style: chartSeriesStyle(item.styleIndex) }), _jsx("span", { className: "min-w-0 break-words", children: item.name })] }, item.id))) }));
}
//# sourceMappingURL=ChartLegend.js.map